var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.221 3.32a.8.8 0 01.615-.287h8.58a.8.8 0 01.8.8v7.917a.8.8 0 01-.8.8h-8.55a.8.8 0 01-.634-.313L1.05 8.102a.8.8 0 01.02-1l3.151-3.781z",
    stroke: "#262A33",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.333 10.083l2.292-2.292m0 0L6.333 5.5M8.625 7.79l2.292 2.292M8.625 7.791L10.917 5.5",
    stroke: "#262A33",
    strokeWidth: 0.9,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/keyboard_delete.9f7212e2.svg";
export { SvgKeyboardDelete as ReactComponent };